import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { interpolateDoubleBracesString } from '@frontend/sports/common/core/utils/string';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, map } from 'rxjs';

import { BetBuilderNotificationService } from '../../../../digital/services/bet-builder-notification.service';
import { AlertType } from '../../../alerts/models';
import { selectHasMinSelectionsBetBuilderError } from '../../../validation/selectors';
import { selectQuickBetBetBuilderPicksCount } from '../../quick-bet.selectors';

@Component({
    selector: 'bs-quick-bet-bet-builder-notification',
    templateUrl: './quick-bet-bet-builder-notification.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./quick-bet-bet-builder-notification.component.scss'],
    standalone: false,
})
export class QuickBetBetBuilderNotificationComponent {
    MISSING_LEGS_COUNT_AFTER_ONE_IS_SELECTED = 1;

    protected errorMessage$: Observable<string | null>;
    protected alertType = AlertType.Information;

    constructor(
        store: Store,
        sitecore: Sitecore,
        private betBuilderNotificationService: BetBuilderNotificationService,
    ) {
        this.errorMessage$ = combineLatest([
            this.betBuilderNotificationService.isBetBuilderTabActive$,
            store.select(selectHasMinSelectionsBetBuilderError),
            store.select(selectQuickBetBetBuilderPicksCount),
        ]).pipe(
            map(([isBetBuilderTabActive, minSelectionError, betBuilderPicksCount]) => {
                if (minSelectionError) {
                    return interpolateDoubleBracesString(sitecore.betBuilderEntainUI.messages?.QuickBetNonSufficientSelections, {
                        count: this.MISSING_LEGS_COUNT_AFTER_ONE_IS_SELECTED,
                    });
                } else if (!isBetBuilderTabActive) {
                    return null;
                } else {
                    return betBuilderPicksCount ? null : sitecore.betslip.validation.SelectMinComboBets;
                }
            }),
        );
    }
}
